export const sourceOfFundsListColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'riskCategory',
    label: 'Risk category',
  },
  {
    name: 'riskScore',
    label: 'Score',
  },
  {
    name: 'name',
    label: 'Source of funds',
  },
];

export const sourceOfFundsListDefaultSorter = {};

export const sourceOfFundsListSchema = {};

export const sourceOfFundsListFiltersSchema = [];
